import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import Constant from "../Constant";

import "../../css/style.css";
import $ from "jquery";
import { getAccessToken } from "../../hooks/AccessToken";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

class DataManagement extends Component {
  state = {
    ERROR: true,
    DataList: [],
    selectValue: "",
    length: "",
    pageNo: "",
    defaultPageNo: 1,
    sortByAttribute: 1,
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  //----------------------------------Change status-----------------------------------------------\\

  changeStatus = async (id, status) => {
    try {
      let token = getAccessToken();
      const response = await Axios.patch(
        Constant.apiBasePath + "content-thumbnail/changeStatus/" + id,
        { status: status ? 0 : 1 },
        { headers: { token: token } }
      );
      let { data } = response;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit(this.state.defaultPageNo);
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //------------------------------------Integrate API for remove banner-------------------------------//

  deleteThumbnail = async (event, thumbnail) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        Constant.apiBasePath +
          "content-thumbnail/delete/" +
          event +
          "?thumbnail=" +
          thumbnail,
        { headers: { token: token } }
      );
      let data = response.data;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit(this.state.defaultPageNo);
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //----------------------------------Integrate show banner API----------------------------------\\

  handleSubmit = async (event, sort) => {
    try {
      let token = getAccessToken();
      let selectValue = $("#selectValue").val();
      const response = await Axios.post(
        Constant.apiBasePath + "content-thumbnail/get-all",
        { key: selectValue, pageNo: event },
        { headers: { token: token } }
      );
      const { data, length, pageNo } = response.data;
      this.setState({
        DataList: data,
        length: length,
        pageNo: pageNo,
        defaultPageNo: event,
        selectValue: "",
        ERROR: false,
      });
    } catch (err) {
      console.log(err);
    }
  };

  //--------------------------------------------Reload component----------------------------------------------//

  componentDidMount() {
    this.handleSubmit(this.state.defaultPageNo);
  }

  //-------------------------------------------End API-------------------------------------------------------\\

  render() {
    const { DataList, length, pageNo } = this.state;
    let i = (pageNo - 1) * Constant.perPage;

    let bodyData = "";
    if (DataList.length > 0) {
      bodyData = DataList.map((el) => {
        i++;
        let status = "Inactive";
        if (el.status === 1) {
          status = "Active";
        }

        const statusClass = el.status === 1 ? "is-active" : "is-inactive";

        return (
          <tr key={el._id}>
            <td>{i}</td>
            <td className="namecol">{el.title}</td>
            <td>
              <img
                src={el.thumbnail}
                alt="ind"
                style={{ width: 50, height: 50 }}
              />
            </td>
            <td>{el.createdAt}</td>
            <td>
              <button
                type="button"
                className={`contest-status-pill ${statusClass}`}
                onClick={() => {
                  this.changeStatus(el._id, el.status);
                }}
              >
                {status}
              </button>
            </td>
            <td className="actions-col thumbnail-actions-col">
              <button
                type="button"
                className="contest-icon-btn danger"
                title="Delete thumbnail"
                aria-label="Delete thumbnail"
                onClick={() => {
                  if (window.confirm("Delete the Thumbnail?")) {
                    this.deleteThumbnail(el._id, el.thumbnail);
                  }
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
              </button>
            </td>
          </tr>
        );
      });
    }

    let previous = 0;
    let next = 0;
    let customLength = 0;

    if (pageNo !== 0) {
      previous = pageNo - 1;
      next = pageNo + 1;
    }

    if (length !== 0) {
      customLength = length;
    }

    if (length < 2) {
      $(".pagination").hide();
    }

    return (
      <div className="content-page contest-submissions-page contest-management-page thumbnail-management-page event-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Thumbnail Management</h4>
                <p className="header-subtitle">
                  Manage content thumbnails, status, and visibility.
                </p>
              </div>
              <div className="header-actions">
                <Link
                  to="/upload-thumbnail"
                  className="btn btn-primary btn-add-event contest-add-match"
                >
                  + Add New
                </Link>
              </div>
            </div>
          </div>

          <div className="event-management-body">
            <div className="card contest-like-card">
              <div className="card-body">
                <div className="thumbnail-management-toolbar">
                  <div className="thumbnail-management-filter-group">
                    <select
                      id="selectValue"
                      onChange={() => {
                        this.handleSubmit(this.state.defaultPageNo);
                      }}
                      className="form-control"
                    >
                      <option value="all">Select one</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                  <p id="gen-message" className="message-feedback"></p>
                </div>

                <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                  {DataList.length > 0 ? (
                    <table
                      id="complex-header-datatable"
                      className="table event-table contest-submissions-table contest-like-table thumbnail-management-table"
                    >
                      <thead>
                        <tr>
                          <th className="thumbnail-sno-col">S.No.</th>
                          <th>Title</th>
                          <th className="thumbnail-image-col">Thumbnail</th>
                          <th>Created At</th>
                          <th className="thumbnail-status-col">Status</th>
                          <th className="actions-col">Action</th>
                        </tr>
                      </thead>
                      <tbody>{bodyData}</tbody>
                    </table>
                  ) : (
                    <p>No thumbnails found.</p>
                  )}

                  {DataList.length > 0 && length > 1 ? (
                    <div className="pagination">
                      {pageNo <= 1 ? (
                        <a>Previous</a>
                      ) : (
                        <a
                          className="paginate-link"
                          onClick={() => this.handleSubmit(previous)}
                        >
                          Previous
                        </a>
                      )}

                      <a>{pageNo}</a>
                      {pageNo >= customLength ? (
                        <a>Next</a>
                      ) : (
                        <a
                          className="paginate-link active"
                          onClick={() => this.handleSubmit(next)}
                        >
                          Next
                        </a>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default DataManagement;
